export default {
    title: '中惠科技',
    description: '中惠科技既有在工程建设领域耕耘20余年的行业精英,又有专注互联网发展的技术英才，多年来通过对建设方、咨询机构、造价机构、招标机构需求的分析研究，逐步形成了“惠系列”产品，实现对工程建设领域和政府的信息化产品与服务。',
    keywords: '工程建设,互联网+,电子招投标,惠系列,造价,采购,SAAS,投资人,建设单位,咨询机构,互联网+,招标采购,企业招标采购,土地产权,农村产权,国有资产交易,惠招标,惠采购,保函通',
    downloadUrl: {
        exe: '',
        zip: '',
    },
};